import { Component } from "react";
import { safeGet, safeSet } from "../lib/safeStorage";

export class PublicAppErrorBoundary extends Component {
  state = { failed: false };

  static getDerivedStateFromError() {
    return { failed: true };
  }

  recover = async () => {
    const cart = safeGet("aramfix-cart");
    if (cart) safeSet(`aramfix-cart-recovery-${Date.now()}`, cart);
    try {
      const registrations = navigator.serviceWorker ? await navigator.serviceWorker.getRegistrations() : [];
      await Promise.all(registrations.map((registration) => registration.update()));
      const keys = window.caches ? await window.caches.keys() : [];
      await Promise.all(keys.filter((key) => key.startsWith("aramfix-") || key.startsWith("aramfix-")).map((key) => window.caches.delete(key)));
    } catch {
      // Recovery continues even when browser cache APIs are unavailable.
    }
    const url = new URL(window.location.href);
    url.searchParams.set("_recover", Date.now());
    window.location.replace(url.toString());
  };

  render() {
    if (!this.state.failed) return this.props.children;
    return <main className="public-app-error" data-testid="public-app-error">
      <p>ARAMFIX</p>
      <h1 data-testid="public-app-error-heading">De website kon niet volledig worden geladen</h1>
      <p data-testid="public-app-error-cart-message">Je winkelwagen blijft veilig bewaard. Herstel de website om verder te gaan.</p>
      <button type="button" onClick={this.recover} data-testid="public-app-recover-button">Website herstellen</button>
    </main>;
  }
}